
import Vue from 'vue';
import _ from 'lodash';
import moment from 'moment';
import axios from '../../../plugins/axios.js';
import { Component, Provide, Ref } from 'vue-property-decorator';

@Component
export default class AddRefundRecordModal extends Vue {
    @Provide() private isModalVisible: boolean = false;
    @Provide() private isLoading: boolean = false;
    @Provide() private record: any = {
        tradeNo: '',
        applicationTime: moment().format('YYYY-MM-DD HH:mm'),
        refundAmount: '',
        refundTime: moment().format('YYYY-MM-DD HH:mm'),
        refundChannel: '',
        remark: '',
    };
    @Provide() private rules: any = {
        tradeNo: [
            { required: true, message: '请输入订单号', trigger: 'blur' },
        ],
        applicationTime: [
            { required: true, message: '请选择申请时间', trigger: 'blur' },
        ],
        refundAmount: [
            { required: true, message: '请输入退费金额', trigger: 'blur' },
        ],
        refundTime: [
            { required: true, message: '请选择退费时间', trigger: 'blur' },
            { validator: this.validateRefundTime, trigger: 'blur' },
        ],
        refundChannel: [
            { required: true, message: '请选择退费渠道', trigger: 'blur' },
        ],
    };
    @Ref() private readonly recordForm;

    private created() {
        this.$on('open', () => {
            this.isModalVisible = true;
        });
    }

    private confirmAddRefundRecord() {
        this.recordForm.validate((valid) => {
            if (!valid) {
                return;
            }
            this.$confirm('记录退费后无法撤回，是否继续？', '确认记录', {
                confirmButtonText: '确定',
                confirmButtonClass: 'el-button--danger',
                cancelButtonText: '取消',
            }).then(() => {
                this.requestRecordRefund();
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消',
                });
            });
        });
    }

    private requestRecordRefund() {
        this.isLoading = true;
        this.record.remark = this.record.remark.trim();
        axios.post('/api/v1/transaction/refund-record', this.record).then(() => {
            this.isModalVisible = false;
            this.clearForm();
            this.$emit('refresh-records');
        }).catch((error) => {
            this.$message.error(error);
        }).then(() => {
            this.isLoading = false;
        });
    }

    private clearForm() {
        this.record = {
            tradeNo: '',
            applicationTime: moment().format('YYYY-MM-DD HH:mm'),
            refundAmount: '',
            refundTime: moment().format('YYYY-MM-DD HH:mm'),
            refundChannel: '',
            remark: '',
        };
    }

    private validateRefundTime(rule: any, value: any, callback: any) {
        if (value && this.record.applicationTime) {
            const applicationTime = moment(this.record.applicationTime);
            const refundTime = moment(value);
            if (refundTime.isBefore(applicationTime)) {
                return callback(new Error('退费时间不能早于申请时间'));
            }
        }
        return callback();
    }
}
